export const PHASES = {
  TYPING: 'typing',
  PAUSING: 'pausing',
  ERASING: 'erasing',
} as const;

export const DEFAULT_TYPING_SPEED = 25;
export const DEFAULT_PAUSE_DURATION = 4000;
export const DEFAULT_ERASING_SPEED = 10;
